export function validateSource(event: MessageEvent, iframe: HTMLIFrameElement | null) {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!iframe) {
        return window.parent === event.source;
    }

    return event.source === iframe.contentWindow;
}

export function validateOrigin(event: MessageEvent, iframe: HTMLIFrameElement | null) {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!iframe) {
        const windowParentURL = new URL(window.parent.location.href);
        const windowURL = new URL(window.location.href);

        return windowParentURL.origin === windowURL.origin;
    }

    const iframeURL = new URL(iframe.src);
    const iframeOrigin = iframeURL.origin;

    return event.origin === iframeOrigin;
}
